// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"68":"9c9e19dd73c8c3bb","320":"b9b5520e99912e7b","817":"39c2ee6df0a4f86c","991":"1b78704124303b00"}[chunkId] + ".js";
};